import { render, staticRenderFns } from "./PropertyRentalMonth.vue?vue&type=template&id=70b962f6"
import script from "./PropertyRentalMonth.vue?vue&type=script&lang=js"
export * from "./PropertyRentalMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports